<template>
  <div style="min-height: 100%;height: 1px;">
    <b-navbar
      class="navbar header has-shadow is-primary"
      role="navigation"
      aria-label="main navigation"
      :mobile-burger="false"
      fixed-top
    >
      <template #brand>
        <b-navbar-item tag="a" href="/">
          <img
            src="@/assets/placeholder.svg"
            width="28"
            height="28"
            alt="Logo"
          />
          <img
            src="@/assets/logo-text.png"
            width="130"
            height="20"
            alt="Logo"
          />
        </b-navbar-item>
        <div
          class="navbar-burger mr-1"
          v-if="isAuthenticated && $route.name != 'register'"
          @click="toggleSidebar"
        >
          <span />
          <span />
          <span />
        </div>
      </template>
    </b-navbar>

    <section
      style="min-height: 100%;height: 1px"
      class="main-content columns is-multiline mx-0 mt-0"
    >
      <b-sidebar
        v-if="isAuthenticated && showSidebar && $route.name != 'register'"
        position="static"
        type="is-light"
        :open="isAuthenticated && showSidebar && $route.name != 'register'"
        fullheight
        mobile="fullwidth"
        class="column is-narrow p-0"
        :class="sidebarClass"
        style="min-height: 100%;height: auto;"
      >
        <div class="p-3">
          <b-menu class="is-custom-mobile" activable>
            <b-menu-list label="Menu">
              <template v-for="item in authenticatedItems">
                <template v-if="item.children">
                  <b-menu-item :key="item.title" :icon="item.icon">
                    <template #label="props">
                      {{ item.title }}
                      <b-icon
                        class="is-pulled-right"
                        :icon="props.expanded ? 'menu-down' : 'menu-up'"
                      ></b-icon>
                    </template>

                    <b-menu-item
                      v-for="childItem in item.children"
                      :key="childItem.title"
                      :label="childItem.title"
                      :icon="childItem.icon"
                      :to="childItem.to"
                      tag="router-link"
                    ></b-menu-item>
                  </b-menu-item>
                </template>
                <template v-else>
                  <b-menu-item
                    :key="item.title"
                    :label="item.title"
                    :icon="item.icon"
                    :to="item.to"
                    tag="router-link"
                  ></b-menu-item>
                </template>
              </template>
              <b-menu-item
                label="Sair"
                icon="logout"
                @click="logout"
              ></b-menu-item>
            </b-menu-list>
          </b-menu>
        </div>
      </b-sidebar>

      <div class="column is-relative p-0" style="min-height: 100%;height: auto">
        <b-loading
          v-if="isLoadingRoute"
          :is-full-page="false"
          v-model="isLoadingRoute"
        />
        <slot v-else />
      </div>
    </section>
    <quick-status-update-modal
      v-if="isModalAtualizacaoRapidaOpen"
      :isModalOpen="isModalAtualizacaoRapidaOpen"
      @toggle="val => (isModalAtualizacaoRapidaOpen = val)"
      :onClose="() => {}"
    />
  </div>
</template>

<script>
import QuickStatusUpdateModal from '@/components/common/QuickStatusUpdateModal.vue';
import { mapGetters, mapActions } from 'vuex';
import api from '@/api';

export default {
  components: { QuickStatusUpdateModal },
  data() {
    return {
      showSidebar: this.$screen.md,
      isModalAtualizacaoRapidaOpen: false,
      authenticatedItems: [
        {
          title: 'Mapas',
          icon: 'map',
          children: [
            {
              title: 'Mapa de casos',
              to: { name: 'case-map' },
            },
            {
              title: 'Mapa de Ajuda',
              to: { name: 'help-map' },
            },
          ],
        },
        {
          title: 'Mural',
          icon: 'table',
          to: { name: 'board' },
        },
        {
          title: 'Atualizar Situação',
          icon: 'book-account',
          to: { name: 'update-status' },
        },
        {
          title: 'Estatísticas',
          icon: 'poll',
          to: { name: 'statistics' },
        },
        {
          title: 'Pedir Ajuda',
          icon: 'handshake',
          to: { name: 'ask-help' },
        },
        {
          title: 'Oferecer Ajuda',
          icon: 'hand-heart',
          to: { name: 'offer-help' },
        },
        {
          title: 'Meus Dados',
          icon: 'account',
          to: { name: 'my-info' },
        },
      ],
    };
  },
  computed: {
    sidebarClass() {
      return {
        'is-sidebar-fixed': !this.$screen.md,
      };
    },
    ...mapGetters(['isAuthenticated', 'isLoadingRoute']),
  },
  watch: {
    $route(to) {
      if (
        this.isAuthenticated
        && to.name !== 'my-info'
        && to.meta.requiresAuth
      ) {
        api.get('/usuario/pendencias').then((res) => {
          const { pendencias } = res.data;
          if (pendencias.deve_atualizar_email) {
            this.$buefy.notification.open({
              message: 'Precisamos que você atualize seus dados!',
              type: 'is-warning',
            });
            this.$router.push({ name: 'my-info' });
          } else if (pendencias.deve_informar_situacao) {
            // this.isModalAtualizacaoRapidaOpen = true;
          }
        });
      }
    },
    '$screen.width': function screenWidth() {
      this.showSidebar = this.$screen.md;
    },
  },
  methods: {
    ...mapActions(['logout']),
    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    },
  },
};
</script>
<style scoped>
.navbar,
.navbar-burger {
  display: block;
}

.is-sidebar-fixed {
  position: fixed;
  width: 100%;
  z-index: 1400;
}
</style>
